module.exports = "/images/old-way-img.svg?410f42337a4c95081fab8161bdfd1253";